import React, { useState, useEffect } from "react";
import axios from "axios";
import UserCard from "./UserCard";
import SendcoinsOpen from "./SendcoinsOpen";
import Banner from "../../assets/community.jpg";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import BuyDM from "../modals/BuyDM";
import SortAndFilter from "../../components/CommunityPage/SortAndFilter";

const Community = () => {
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState({ businessName: "", _id: "" });
  const [showModal, setShowModal] = useState(false);
  const [showBuyModal, setShowBuyModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage] = useState(12);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({
    type: "",
    text: "",
  });
  const [sortAndFilter, setSortAndFilter] = useState("");

  useEffect(() => {
    loadUsers();
  }, [filter]);

  const loadUsers = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_LOCAL_API}/community?type=${filter.type}&searchTerm=${filter.text}`,
    };

    axios
      .request(config)
      .then((response) => {
        setCurrentPage(1);
        setUsers(response.data.data);
        setLoading(false);
      })
      .catch(() => {});
  };

  const handleViewProfile = (user) => {
    setSelected(user);
    setShowModal(true);
  };


  const handleBuyModal = () => {
    setShowBuyModal(true);
  };


  // Logic for pagination
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="community-page">
      <div className="community-banner">
        <img
          className="banner-image"
          src={Banner}
          alt="community"
        />
      </div>
      <div className="community-description">
        <p>
          Purchasing Donor Money directly from a nonprofit or impact enterprise
          doubles your impact by creating a circular flow of funding that grows as
          the use and value of Donor Money increases. While we work to integrate
          payment gateways, please reach out directly to the following
          organizations with Donor Money balances to arrange purchase and payment
          directly from them.
        </p>
      </div>
      <div className="filterBoxCom">
        <div>
          <input
            type="text"
            placeholder="Search Organisation by name"
            value={filter.text}
            onChange={(e) => setFilter({ ...filter, text: e.target.value })}
          />
          <select
            value={filter.type}
            onChange={(e) => setFilter({ ...filter, type: e.target.value })}
          >
            <option value=""> Select Type</option>
            <option value="impactOrg">Impact Organisation</option>
            <option value="ngo">NGO</option>
          </select>
        </div>
        <SortAndFilter users={users} setUsers={setUsers} setSortAndFilter={setSortAndFilter} sortAndFilter={sortAndFilter} />
      </div>
      <div className="community-container">
        {loading ? (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
              gap: "20px",
              width: "100%",
              padding: "20px",
            }}
          >
            {Array.from({ length: 12 }).map((_, index) => (
              <div key={index} style={{ minWidth: "320px", maxWidth: "320px", flex: "1 1 150px" }}>
                <Skeleton
                  enableAnimation={true}
                  duration={1}
                  baseColor="#585757"
                  highlightColor="#bebebe"
                  height={150}
                />
                <Skeleton
                  enableAnimation={true}
                  duration={1}
                  baseColor="#585757"
                  highlightColor="#bebebe"
                  width="80%"
                  style={{ marginTop: 10 }}
                />
                <Skeleton
                  enableAnimation={true}
                  duration={1}
                  baseColor="#585757"
                  highlightColor="#bebebe"
                  width="60%"
                  style={{ marginTop: 10 }}
                />
              </div>
            ))}
          </div>
        ) : (
          <div>
            <div id="cards-container">
              {currentUsers.map((user) => (
                <div
                  style={{
                    cursor: "pointer",
                    WebkitTapHighlightColor: "transparent",
                  }}
                  onClick={() =>
                    (window.location.href = `/Community/${user.userName}`)
                  }
                  key={user._id}
                >
                  <UserCard user={user} onBuyModal={handleBuyModal} onViewProfile={handleViewProfile} />
                </div>
              ))}
            </div>
            {/* Pagination controls */}
            <nav style={{ display: "flex", justifyContent: "center" }}>
              <ul className="pagination">
                {Array.from(
                  { length: Math.ceil(users.length / usersPerPage) },
                  (_, index) => (
                    <li
                      key={index}
                      className={`page-item ${currentPage === index + 1 ? "active" : ""
                        }`}
                    >
                      <button
                        onClick={() => paginate(index + 1)}
                        className="page-link"
                      >
                        {index + 1}
                      </button>
                    </li>
                  )
                )}
              </ul>
            </nav>
          </div>
        )}
        <BuyDM isModalOpen={showBuyModal} setIsModalOpen={setShowBuyModal} />
        <SendcoinsOpen showModal={showModal} closeModal={() => setShowModal(false)} user={selected} />
      </div>
    </div>
  );
};

export default Community;
